import React from "react";
import { Controller, useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { intl } from "LocaleWrapper";
import { Button, Card, FormGroup, Select } from "@cofano/cck";
import { Box, Grid2 as Grid } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { FormErrorMessage } from "components/form/FormErrorMessage";
import { Language } from "imports/Utils";
import RelationSelect from "view/relations/components/selects/RelationSelect";
import { LocationSchemaInput, LocationSchemaOutput } from "view/locations/utils/location.schema";
import { LocationUserType } from "__generated__/enums";

const LocationRelationsForm = () => {

	const { control } = useFormContext<LocationSchemaInput, unknown, LocationSchemaOutput>();

	const { fields, append, remove } = useFieldArray({
		control,
		name: "relationUsers",
	});

	const [ relationUsers ] = useWatch({ control, name: [ "relationUsers" ] });

	return (
		<Box p={2} pt={fields.length === 0 ? 2 : 0}>
			{fields.map((field, index) => {
				return (
					<Card
						key={field.id}
						title={relationUsers?.[index]?.customer?.name || Language("RELATION")}
						actions={[ {
							onClick: () => remove(index),
							icon: <DeleteIcon />,
						} ]}
						collapsable>
						<Grid spacing={3} container>
							<Grid size={6}>
								<FormGroup label={Language("RELATION")} overflow="hidden" required>
									<Controller
										name={`relationUsers.${index}.customer`}
										control={control}
										render={({ field, formState }) => (
											<React.Fragment>
												<RelationSelect {...field} />
												<FormErrorMessage name={field.name} errors={formState.errors} />
											</React.Fragment>
										)} />
								</FormGroup>
							</Grid>

							<Grid size={6}>
								<FormGroup label={Language("TYPE")} overflow="hidden">
									<Controller
										name={`relationUsers.${index}.type`}
										control={control}
										render={({ field }) => (
											<Select
												{...field}
												fetchOptions={Object.values(LocationUserType)}
												getOptionLabel={option => intl.formatMessage({ id: `LOCATION_${option}` })}
												clearable={false}
												disableSearch />
										)} />
								</FormGroup>
							</Grid>
						</Grid>
					</Card>
				);
			})}

			<Box>
				<Button
					icon={<AddIcon />}
					onClick={() => {
						append({
							id: null,
							customer: null,
							type: LocationUserType.Owner,
						});
					}}
					size="small"
					variant="outlined" />
			</Box>
		</Box>
	);
};

export default LocationRelationsForm;
